export default "__VITE_ASSET__B$Y2EOio__"